// extracted by mini-css-extract-plugin
export var component = "SmorgasbordApartmentDeclarationModule-module--component--AgyGZ";